import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Usuarios() {
  const { users, user: currentUser } = useAuth();
  const [tab, setTab] = useState('activos');
  const [showModal, setShowModal] = useState(false);
  const [localUsers, setLocalUsers] = useState(users);
  const [form, setForm] = useState({ nombre:'', email:'', password:'', rol:'asesor' });
  const [toast, setToast] = useState('');

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const activos   = localUsers.filter(u => u.activo !== false);
  const inactivos = localUsers.filter(u => u.activo === false);

  const desactivar = (id) => {
    setLocalUsers(prev => prev.map(u => u.id === id ? { ...u, activo: false } : u));
    showToast('Usuario desactivado');
  };

  const reactivar = (id) => {
    setLocalUsers(prev => prev.map(u => u.id === id ? { ...u, activo: true } : u));
    showToast('Usuario reactivado');
  };

  const crearUsuario = () => {
    if (!form.nombre || !form.email || !form.password) { showToast('Completa todos los campos'); return; }
    const nuevo = { id: Date.now(), ...form, activo: true };
    setLocalUsers(prev => [...prev, nuevo]);
    localStorage.setItem('lf_users', JSON.stringify([...localUsers, nuevo]));
    setForm({ nombre:'', email:'', password:'', rol:'asesor' });
    setShowModal(false);
    showToast('Usuario creado');
  };

  const lista = tab === 'activos' ? activos : inactivos;

  return (
    <div style={{ padding:'24px 24px 80px', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h1 style={{ margin:0, fontSize:22, fontWeight:800, color:'#0f172a' }}>Usuarios</h1>
          <p style={{ margin:'4px 0 0', color:'#94a3b8', fontSize:13 }}>{activos.length} usuarios activos</p>
        </div>
        <button onClick={() => setShowModal(true)}
          style={{ padding:'10px 20px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
          + Nuevo usuario
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:8, marginBottom:20 }}>
        {[['activos','Activos',activos.length],['inactivos','Inactivos',inactivos.length]].map(([key,label,count]) => (
          <button key={key} onClick={() => setTab(key)}
            style={{ padding:'8px 18px', borderRadius:8, border:'none', cursor:'pointer', fontSize:13, fontWeight:700,
              background: tab===key ? '#185fa5' : '#fff',
              color: tab===key ? '#fff' : '#475569',
              boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
            {label} ({count})
          </button>
        ))}
      </div>

      {/* Lista */}
      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {lista.length === 0
          ? <div style={{ textAlign:'center', padding:48, color:'#94a3b8' }}>Sin usuarios en esta sección</div>
          : lista.map(u => (
          <div key={u.id} style={{ background:'#fff', borderRadius:12, padding:'14px 20px', boxShadow:'0 1px 3px rgba(0,0,0,0.08)', display:'flex', alignItems:'center', gap:16 }}>
            <div style={{ width:44, height:44, borderRadius:22, background:'#185fa5', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800, fontSize:18, flexShrink:0 }}>
              {u.nombre.charAt(0).toUpperCase()}
            </div>
            <div style={{ flex:1 }}>
              <p style={{ margin:0, fontWeight:700, fontSize:14, color:'#0f172a' }}>{u.nombre}</p>
              <p style={{ margin:'2px 0 0', fontSize:12, color:'#94a3b8' }}>{u.email} · {u.rol}</p>
            </div>
            {u.id !== currentUser?.id && (
              tab === 'activos'
                ? <button onClick={() => desactivar(u.id)}
                    style={{ padding:'7px 14px', background:'none', border:'1px solid #fecaca', color:'#dc2626', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:700 }}>
                    Desactivar
                  </button>
                : <button onClick={() => reactivar(u.id)}
                    style={{ padding:'7px 14px', background:'none', border:'1px solid #bbf7d0', color:'#16a34a', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:700 }}>
                    Reactivar
                  </button>
            )}
          </div>
        ))}
      </div>

      {/* Modal nuevo usuario */}
      {showModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}
          onClick={e => { if(e.target===e.currentTarget) setShowModal(false); }}>
          <div style={{ background:'#fff', borderRadius:16, width:'100%', maxWidth:440, padding:32 }}>
            <h2 style={{ margin:'0 0 20px', fontSize:18, fontWeight:800, color:'#0f172a' }}>Nuevo usuario</h2>
            {[['Nombre completo','nombre','text'],['Usuario (login)','email','text'],['Contraseña','password','password']].map(([label,field,type]) => (
              <div key={field} style={{ marginBottom:14 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:700, color:'#475569', marginBottom:5, textTransform:'uppercase' }}>{label}</label>
                <input type={type} value={form[field]} onChange={e => setForm(p=>({...p,[field]:e.target.value}))}
                  style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', boxSizing:'border-box' }} />
              </div>
            ))}
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:700, color:'#475569', marginBottom:5, textTransform:'uppercase' }}>Rol</label>
              <select value={form.rol} onChange={e=>setForm(p=>({...p,rol:e.target.value}))}
                style={{ width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:13, outline:'none', background:'#fff', boxSizing:'border-box' }}>
                <option value="asesor">Asesor</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setShowModal(false)}
                style={{ flex:1, padding:'10px', border:'1px solid #e2e8f0', background:'#fff', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, color:'#475569' }}>
                Cancelar
              </button>
              <button onClick={crearUsuario}
                style={{ flex:1, padding:'10px', background:'#185fa5', color:'#fff', border:'none', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:700 }}>
                Crear usuario
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <div style={{ position:'fixed', bottom:60, left:'50%', transform:'translateX(-50%)', background:'#0f172a', color:'#fff', padding:'10px 20px', borderRadius:10, fontSize:13, fontWeight:600, zIndex:999 }}>
          {toast}
        </div>
      )}
    </div>
  );
}
